import { FC, useMemo } from "react";
import { Chip, Typography } from "@mui/material";
import { CleanActionTypes, getCleanActionLabel } from "@/utils/clean-options";
import { ResourceType } from "@/services/cloudchipr.api";

interface AutomationsFoundResourcesGridToolbarActionNameProps {
  scheduleAction: string | null;
  action: CleanActionTypes;
  resourceType: ResourceType;
}

export const AutomationsFoundResourcesGridToolbarActionName: FC<
  AutomationsFoundResourcesGridToolbarActionNameProps
> = ({ scheduleAction, resourceType, action }) => {
  const actionName = useMemo(
    () =>
      scheduleAction?.includes("clean") &&
      getCleanActionLabel(action, resourceType),
    [action, scheduleAction, resourceType],
  );

  if (!actionName) {
    return null;
  }

  return (
    <Chip
      variant="filled"
      size="small"
      sx={{ mr: 2 }}
      label={
        <Typography variant="caption">
          Action:{" "}
          <Typography component="span" fontWeight="medium" variant="inherit">
            {actionName}
          </Typography>
        </Typography>
      }
    />
  );
};
